import { Navbar , Nav, Container,NavDropdown} from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useState, useEffect, } from 'react'
import './Navbar.css';

function Navigation() {



  const [show, setShow] = useState(false);
  const [button,setButton] = useState(true);


   

  const showButton = () =>{
    if(window.innerWidth <= 960){
      setButton(false);
      setNavbar(true);
    }
    else{
      setButton(true);
    }
  }
  
  const showDropdown = (e)=>{
      setShow(!show);
  }
  const hideDropdown = e => {
      setShow(false);
  }

const [navbar,setNavbar] = useState(false);

  const changeBackground = () =>{
    if(button){
    if(window.scrollY>=80){
      setNavbar(true);
    }
    else{
      setNavbar(false);
    }
  }
  else{
    setNavbar(true);
  }
  }
  useEffect(()=>{
    showButton();
  },[]);

  window.addEventListener('resize',showButton);

window.addEventListener('scroll',changeBackground);

return(
<Navbar style={{backgroundColor:navbar?'white':'transparent',transition:'1000ms',}} collapseOnSelect expand="lg" variant={navbar?"light":"dark"} fixed='top'>
  <Navbar.Brand style={{fontSize:30,letterSpacing:4,fontWeight:'bolder',fontFamily:'Eczars'}} href="/">SITMO</Navbar.Brand>
  <Navbar.Toggle aria-controls="responsie-navbar-nav" />
  <Navbar.Collapse id="responsive-navbar-nav" className="justify-content-end" style={{paddingRight:50}}>

    <Nav   style={{}}>
    <Nav.Link className='navLink'  style={{marginRight:25}} href="/">Home</Nav.Link>
    <NavDropdown  title="Products" id="collasible-nav-dropdown"    show={show} style={{marginRight:15}} 
   onMouseEnter={showDropdown} 
   onMouseLeave={hideDropdown}>
        <NavDropdown.Item href='/acp' style={{color:'grey'}} className='navbar-item' >ACP</NavDropdown.Item>
        <NavDropdown.Item style={{color:'grey'}} className='navbar-item'  href="/hpl">HPL</NavDropdown.Item>
        <NavDropdown.Item style={{color:'grey'}} className='navbar-item'  href="/laminates">LAMINATES</NavDropdown.Item>
        <NavDropdown.Item style={{color:'grey'}} className='navbar-item'  href="/plywood">PLYWOOD</NavDropdown.Item>
      </NavDropdown>

      <Nav.Link className='navLink'  style={{marginRight:25}} href="/about">About Us</Nav.Link>
      <Nav.Link className='navLink' eventKey={2} href="/contact">
        Contact Us
      </Nav.Link>
    </Nav>
  </Navbar.Collapse>
</Navbar>
);
} 

export default Navigation;